<div class="upload-step">
  @if (!files().length) {
    <section class="upload-empty-state">
      <div class="upload-empty-state__copy">
        <p class="upload-section-eyebrow">Set fotografico</p>
        <h2
          class="upload-empty-state__title font-display text-gray-900 md:text-5xl"
        >
          Trasforma le tue foto in uno strumento di vendita.
        </h2>

        <div class="upload-empty-state__message">
          <p class="upload-empty-state__message-label hidden md:block">
            Cosa ottieni
          </p>

          <ul class="upload-empty-state__benefits">
            <li class="upload-empty-state__benefit">
              <span class="upload-empty-state__benefit-icon">01</span>
              <div>
                <strong>Svuota e valorizza l'immobile</strong>
                <p class="hidden md:block">
                  Rimuovi arredi, oggetti personali e disordine: mostra la
                  metratura reale e lascia che gli acquirenti immaginino il loro
                  stile.
                </p>
              </div>
            </li>
            <li class="upload-empty-state__benefit">
              <span class="upload-empty-state__benefit-icon">02</span>
              <div>
                <strong>Qualità fotografica professionale</strong>
                <p class="hidden md:block">
                  Luce, contrasto e colori ottimizzati automaticamente. Ogni
                  stanza risulta più luminosa e pronta per il listing.
                </p>
              </div>
            </li>
            <li class="upload-empty-state__benefit">
              <span class="upload-empty-state__benefit-icon">03</span>
              <div>
                <strong>Virtual staging su misura</strong>
                <p class="hidden md:block">
                  Arreda virtualmente ogni ambiente con lo stile che vende di
                  più, senza toccare l'architettura esistente.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="upload-empty-state__panel">
        <casa-doc-input-area-file
          class="upload-empty-state__input grid min-h-[28rem]"
          [multiple]="true"
          accept=".jpg, .jpeg"
          [formControl]="filesControl"
        ></casa-doc-input-area-file>
      </div>
    </section>
  } @else {
    <input
      #replaceInput
      type="file"
      class="hidden"
      multiple
      accept=".jpg, .jpeg"
      (change)="onReplaceSelection($event)"
    />

    <section class="upload-loaded-state">
      <div class="upload-loaded-state__toolbar">
        <div>
          <p class="upload-section-eyebrow">Set pronto</p>
          <h2
            class="upload-loaded-state__title font-display text-gray-900 md:text-4xl"
          >
            {{ files().length }} foto pronte per la staging
          </h2>
          <p
            class="mt-2 hidden max-w-3xl text-sm leading-6 text-gray-500 md:block"
          >
            Controlla le immagini prima di procedere. Per cambiare selezione,
            carica un nuovo set. Il sistema sostituirà tutto.
          </p>
        </div>

        <div
          class="upload-loaded-state__actions mobile-action-bar mobile-action-bar--upload"
        >
          <button
            type="button"
            class="btn-outline-gray"
            (click)="replaceInput.click()"
          >
            Sostituisci foto
          </button>
          <button type="button" class="btn-outline-gray" (click)="onClear()">
            Svuota tutto
          </button>
          <button
            type="button"
            class="btn-solid-blue-casa-doc"
            (click)="onProceed()"
          >
            Imposta lo stile
          </button>
        </div>
      </div>

      <div class="upload-grid">
        @for (file of files(); track file.name + $index) {
          <figure class="upload-grid__item">
            <div class="upload-grid__media">
              <img
                class="h-full w-full object-cover"
                [src]="file | fileSrc"
                [alt]="file.name"
              />
            </div>
            <figcaption class="upload-grid__caption">
              <span class="truncate">{{ file.name }}</span>
              <span class="upload-grid__badge">Pronto</span>
            </figcaption>
          </figure>
        }
      </div>
    </section>
  }
</div>
